<div class="document-link-container">
    @if (ready) {
        <div class="detail-page-card">
            <div class="detail-page-card-title">Linked Documents</div>
            <div class="detail-page-card-actions">
                @if (permissions.canLinkDocuments) {
                    <button class="btn btn-raised blue" (click)="openLinkPopup()">
                        <i class="fas fa-link"></i>
                        <span class="ms-2">Link</span>
                    </button>
                }
            </div>

            <document-manager
                NoDocumentMessage="No documents linked"
                [(Documents)]="linked"
                [AllowAdd]="false"
                [AllowDelete]="false"
                [disabled]="false"
                [DocumentTypeTargets]="documentTargetModule"
                [ExtraFieldColumnConfig]="documentExtraColumns"
            ></document-manager>
        </div>
    } @else {
        <div class="fancy-loader submodule"></div>
    }
</div>

<ng-template #linkableComp>
    @if (permissions.canLinkDocuments && ready) {
        <app-linkable
            typename="documents"
            idValueProp="ID"
            displayValueProp="Name"
            [orderByValueProperty]="true"
            [linked]="linked"
            [unlinked]="unlinked"
            [hidePanelToggle]="true"
            [linkablePaginationItemCount]="12"
            (linkedChange)="linkedChanged($event)"
        >
        </app-linkable>
    }
</ng-template>
